import React from 'react'

import { useParams } from 'react-router-dom'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import { PmcForm } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'

const PmcShow = () => {
  const { monitoringManagementPmcId } = useParams()

  const { response, isLoading } = useFetch(
    service.dponet.monitoringManagementPmc.show,
    { monitoringManagementPmcId: monitoringManagementPmcId },
    [monitoringManagementPmcId],
  )

  const monitoringManagementPmc = response?.data?.monitoringManagementPmc

  return (
    <Page title="Visualização de PMC - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Plano de Melhoria Contínua (PMC)" />
        <PmcForm monitoringManagementPmc={monitoringManagementPmc} isShow />
      </Container>
    </Page>
  )
}

export default PmcShow
